import { DAYS_OF_WEEK } from '@gozoki/api-types'
import { z } from 'zod'
import { STORE_DASHBOARD_DATE_PRESETS } from '~/components/routes/store-dashboard/filters/date-shortcuts'
import { isoDateSchema } from '~/lib/iso-date'

const windowSearch = {
  storeId: z.number().int().positive().optional(),
  preset: z.enum(STORE_DASHBOARD_DATE_PRESETS).optional(),
  startDate: isoDateSchema.optional(),
  endDate: isoDateSchema.optional(),
  compStartDate: isoDateSchema.optional(),
  compEndDate: isoDateSchema.optional(),
  comparableMode: z.enum(['auto', 'custom']).optional().default('auto'),
}

export const storeDashboardSearchSchema = z.object(windowSearch)
export type StoreDashboardSearch = z.infer<typeof storeDashboardSearchSchema>

export const storeHoursSearchSchema = z.object({
  ...windowSearch,
  days: z
    .array(z.enum(DAYS_OF_WEEK))
    .min(1)
    .optional()
    .default([...DAYS_OF_WEEK]),
  plage: z.enum(['AM', 'PM', 'DAY']).optional().default('DAY'),
})
export type StoreHoursSearch = z.infer<typeof storeHoursSearchSchema>
